import { ButtonHTMLAttributes, ReactNode } from "react";
import "./GradientShareButton.css";

type GradientShareButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  children: ReactNode;
  icon?: string;
};

function joinClassNames(...classes: Array<string | undefined>) {
  return classes.filter(Boolean).join(" ");
}

export default function GradientShareButton({
  children,
  className,
  icon = "share",
  type = "button",
  ...props
}: GradientShareButtonProps) {
  return (
    <button
      type={type}
      className={joinClassNames("gradient-share-button", className)}
      {...props}
    >
      <span className="material-symbols-outlined" aria-hidden="true">
        {icon}
      </span>
      {children}
    </button>
  );
}
